import(/* webpackMode: "eager" */ "/vercel/path0/Website/app/(home)/referral/ReferralPageComponent.jsx")